import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useState, useEffect } from 'react'
import ProductPriceListRow from './ProductPriceListRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faDollarSign, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { canManageProducts } from '../global_context/capabilities/productCapabilities'
import { Dropdown, Table } from 'react-bootstrap'
import { AsyncPaginate } from 'react-select-async-paginate'

const ProductPriceListsTab = ({ data, id }) => {
  const [priceListsData, setPriceListsData] = useState({ table: [] })
  const [isFetching, setIsFetching] = useState(true)
  const [addNewPriceList, setAddNewPriceList] = useState(false)
  const [missingPriceLists, setMissingPriceLists] = useState([])
  const [price, setPrice] = useState(null)
  const [priceListId, setPriceListId] = useState(null)
  const [invalidPriceListId, setInvalidPriceListId] = useState(false)
  const [searchInput, setSearchInput] = useState('')
  const [pricelistCode, setPricelistCode] = useState(null)
  const [selectedPriceListOption, setSelectedPriceListOption] = useState(null)

  useEffect(() => {
    fetchDataFromServer()
  }, [])

  const handleSearch = (event) => {
    setSearchInput(event.target.value)
  }

  const handleEnterSearch = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      fetchDataFromServer()
    }
  }

  const fetchDataFromServer = () => {
    setIsFetching(true)

    authFetch(`${BASE_BACKEND_URL}/products/${id}/product_pricelist/missing_pricelists`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => setMissingPriceLists(data || []))
      .catch((e) => {
        console.log(e)
        setMissingPriceLists([])
      })

    authFetch(`${BASE_BACKEND_URL}/products/${id}/product_pricelist`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        const filteredData = filterDataBySearchTerm(data, searchInput)
        setPriceListsData(filteredData)
        setIsFetching(false)
      })
      .catch((e) => {
        console.log(e)
        setPriceListsData({ table: [] })
        setIsFetching(false)
      })
  }

  const filterDataBySearchTerm = (data, searchTerm) => {
    if (!searchTerm) {
      return data
    }

    const filteredData = data['table'].filter((obj) =>
      Object.values(obj).some((value) =>
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    )

    return { ...data, table: filteredData }
  }

  const resetNewPriceList = () => {
    setPrice(null)
    setPriceListId(null)
    setPricelistCode(null)
    setSelectedPriceListOption(null)
    setInvalidPriceListId(false)
  }

  const startAddingNewPriceList = () => {
    resetNewPriceList()
    setAddNewPriceList(true)
  }

  const cancelAddNewPriceList = () => {
    setAddNewPriceList(false)
  }

  const sendAddNewPriceList = (event) => {
    event.preventDefault()
    if (priceListId == null) {
      setInvalidPriceListId(true)
    } else {
      setInvalidPriceListId(false)
      authFetch(`${BASE_BACKEND_URL}/product_pricelist/`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          price,
          product_id: id,
          price_list_id: priceListId,
          pricelist_code: pricelistCode
        })
      })
        .then((response) => {
          if (!response?.ok) throw new Error('No se pudo asignar la lista de precios')
          return response.json()
        })
        .then(() => {
          resetNewPriceList()
          setAddNewPriceList(false)
          fetchDataFromServer()
        })
        .catch((e) => console.log(e))
    }
  }

  const handleInputPriceChange = (event) => {
    setPrice(event.target.value)
  }

  const loadPriceListsOptions = async (search, loadedOptions, { page }) => {
    if (!missingPriceLists || missingPriceLists.length === 0) {
      return {
        options: [],
        hasMore: false
      }
    }

    const filtered = missingPriceLists.filter((obj) => {
      const term = search?.toLowerCase() || ''
      return obj.description.toLowerCase().includes(term) || obj.db_ref.toLowerCase().includes(term)
    })

    const options = filtered.map((obj) => ({
      value: obj.id,
      label: `${obj.description} - ${obj.db_ref}`,
      db_ref: obj.db_ref,
      description: obj.description
    }))

    return {
      options,
      hasMore: false
    }
  }

  const handlePriceListSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedPriceListOption(selectedOption)
      setPriceListId(selectedOption.value)
      setPricelistCode(selectedOption.description)
      setInvalidPriceListId(false)
    } else {
      setSelectedPriceListOption(null)
      setPriceListId(null)
    }
  }

  return (
    <div>
      {addNewPriceList && (
        <form onSubmit={sendAddNewPriceList}>
          <div className="show-header show-product-header">
            <div className="cancel-save-block-list">
              <input
                id="cancel-add"
                onClick={cancelAddNewPriceList}
                className="cancel-edit-button"
                value="Cancelar"
                type="button"
              />
              <input value="Guardar" className="save-button" type="submit" />
            </div>
          </div>

          <div className="add-price-list-block mb-20 promo-form-section">
            <h2>Escoja la lista de precio y coloque el precio para asignarla a su producto:</h2>
            <div className="add-price-list-inputs row g-2 align-items-end flex-nowrap">
              <div className="col-5 col-lg-5 col-md-5">
                <div>
                  <label>Lista de precio:</label>
                </div>

                <AsyncPaginate
                  placeholder="Buscar lista de precio..."
                  debounceTimeout={0}
                  loadOptions={loadPriceListsOptions}
                  additional={{ page: 1 }}
                  isDisabled={isFetching}
                  isClearable
                  cacheOptions
                  menuPlacement="bottom"
                  menuPosition="fixed"
                  loadingMessage={() => 'Cargando...'}
                  noOptionsMessage={() => 'Sin resultados'}
                  value={selectedPriceListOption}
                  onChange={handlePriceListSelect}
                />

                {invalidPriceListId && (
                  <div className="red">
                    Por favor seleccione una lista de precio dentro de las opciones.
                  </div>
                )}
              </div>
              <div className="col-3 col-lg-3 col-md-3">
                <label>Unidad de venta</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Unidad de venta"
                  disabled
                  value={data?.package ? `${data?.package?.unit} DE ${data.package.quantity}` : ''}
                />
              </div>

              <div className="col-2 col-lg-2 col-md-2">
                <label>Precio venta</label>
                <div className="input-group">
                  <span className="input-group-text">$</span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="0.0"
                    step="0.01"
                    min="0"
                    onChange={handleInputPriceChange}
                    value={price ?? ''}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
      {!addNewPriceList && canManageProducts() && (
        <div className="title-and-search-container ">
          <h2></h2>
          <div className="search-input-container mb-20">
            <input
              onClick={startAddingNewPriceList}
              className="add-price-list-button"
              value="+ Agregar lista de precio"
              type="button"
            />
          </div>
        </div>
      )}

      {!addNewPriceList && (
        <div className="title-and-search-container ">
          <h2>Listas de precios asignados a producto:</h2>
          <div className="search-input-container mb-20">
            <input
              value={searchInput}
              onChange={handleSearch}
              onKeyDown={handleEnterSearch}
              className="round-search-input"
              style={{ fontSize: 12 }}
              placeholder="Buscar por código o nombre"
            />
            {searchInput === '' ? (
              <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
            ) : (
              <div
                title="Limpiar texto"
                onClick={() => setSearchInput('')}
                className="round-search-input-x"
              >
                X
              </div>
            )}
          </div>
        </div>
      )}
      <div>
        <Table hover responsive>
          <thead className="table-header-gray">
            <tr>
              <th className="th-header th-code">
                <span className="th-header-text">CÓDIGO</span>
              </th>
              <th className="th-header th-name">
                <span className="th-header-text">NOMBRE</span>
              </th>
              <th className="th-header th-unit">
                <span className="th-header-text">UNIDAD DE VENTsA</span>
              </th>
              <th className="th-header th-price">
                <span className="th-header-text">PRECIO</span>
              </th>
              <th className="th-header th-action">
                <span className="th-header-text">ACCIÓN</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {!isFetching && priceListsData && (
              <>
                {priceListsData['table'] && priceListsData['table'].length === 0 && (
                  <tr>
                    <td colSpan="4" className="td-empty">
                      No hay resultados
                    </td>
                  </tr>
                )}
                {priceListsData['table'] &&
                  priceListsData['table'].length > 0 &&
                  priceListsData['table'].map((obj) => (
                    <ProductPriceListRow
                      key={obj.id}
                      obj={obj}
                      id={id}
                      productPackage={data.package}
                      onChanged={fetchDataFromServer}
                    />
                  ))}
              </>
            )}
            {isFetching && (
              <tr>
                <td className="td-empty" colSpan="4">
                  Obteniendo datos...
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default ProductPriceListsTab
